import { Component, OnInit } from '@angular/core';
import { NbTreeGridDataSource, NbTreeGridDataSourceBuilder } from '@nebular/theme';
import { FormControl } from '@angular/forms';
import { NbSearchService } from '@nebular/theme';
import { DashService } from '../dash.service';
import { liveSearch } from '../dash.operator';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import {CustomDaysSummaryComponent} from '../dialog/custom-days-summary/custom-days-summary.component';
import { NbToastrService } from '@nebular/theme';
import { MatDialog } from '@angular/material/dialog';
import { read, utils, writeFile } from 'xlsx';
import * as moment from 'moment';


interface TreeNode<T> {
  data: T;
  children?: TreeNode<T>[];
  expanded?: boolean;
}

interface FSEntry {
  name: string;
  size: string;
  kind: string;
  items?: number;
}


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  customColumn = 'Parameter';
  defaultColumns = ['This week', 'Last week', 'Growth (%)'];
  allColumns = [this.customColumn].concat(this.defaultColumns);
  engagementPeriods = ['Daily', 'Weekly', 'Fortnightly', 'Monthly', 'Quarterly', 'Yearly'];
  dateRange={
    "startDate":"",
    "endDate":""
  };
  monthsArray=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  engagementDays = ['Last 7 days', 'Last 15 days', 'Last 30 days', 'Custom Date Range']; //*
  selectedComparePeriod = '0';

  //*
  selectedDaysPeriod = '0';
  hubsInstallCount: number;
  totalNodesInstalled: number;
  hubsOnlineCount: number;
  totalNodesOnline: number;
  summaryData:object={};
  nodeTypeInstallCount;
  nodeTypeOnlineCount;
  displayedColumnsForNode=['sr','type','count'];
  selectedRadioOptionInstalls:number=1;
  selectedRadioOptionOnline:number=1;
  dataUpdatedTime: Date;
  loading:boolean=true;
  hubUsersData=[];
  tabIndex:number=0;
  installationGraphChecked:boolean=false;
  loadingGraphData:boolean;
  checkedGraphOption:boolean;
  oneYearHubCount:number=0;
  graphDataTimeout:boolean;
  summaryDataTimeout:boolean;
  customSummaryTimeout:boolean;
  //*

  //- firmware analytics
  hubFirmwareVersion: string="";
  hubType: number=1;
  equality: number=1;
  firmwareData;
  releasedNodeTypeData;
  oldHubFirmwareData;
  columnsForFirmwareAnalytics: string[] = ["valueName","valueCount"];
  dataSourceForFirmwareCounts=[];
  dataSourceForTotalFirmwareCounts=[];
  dataSourceForOldHubTotalFirmwareCounts=[];
  loadingAnalytics: boolean=false;
  loadingReleaseAnalytics:boolean = false;
  //-


  //database analytics
  isLoadingDatabaseAnalytics=false;
  databaseInfo={
    totalCustomerHubs: 0,
    totalProvisionCommissionedHubs: 0,
    totalAppCurrentStatusHubs: 0,
    totalPersonalizationHubs: 0,
    totalRedisOnlineHubs:0,
    totalAppCurrentStatusHubsOnline: 0,
    totalAppCurrentStatusHubsOffline: 0,
    lastUpdatedAt: undefined,
  };

  graphDataForLastYear=[];
  graphDataForLastYearLayout={
    title:{
      text: 'HUB Installations for the span of last one year',
      font:{
        size: 20
      }
    },
    xaxis:{
      showticklabels: true,
      tickangle: 45,
      tickfont:{
        size: 13
      }
    },
    yaxis:{
      title:{
        text:'HUB Count',
        font:{
          size: 18
        }
      }
    },
    margin:{
      b: 90
    }
  };

  graphConfig={responsive: true, displayModeBar: true};

  layout = { barmode: 'group' };
  engagementGraph = {
    data: [],
    layout: this.layout
  };
  searchValue = '';
  private dashDataSub: Subscription;
  private dashDataInfoSub: Subscription;
  private dashSummarySub: Subscription;
  private dashCustomSummarySub: Subscription;
  private dashOneYearHubDataSub: Subscription;
  private dashFirmwareDataSub: Subscription;
  private dashReleasedNodeTypeDataSub: Subscription;
  private dashOldHubFirmwareDataSub: Subscription;

  releasedNodeType="";
  customersData = [];
  custDatas = [];
  geoPositions = [];
  totalHubs = 0;
  dashInfo
  readonly position = { lat: 28.644800, lng: 77.216721 };
  grapgConfig = {responsive: true, displayModeBar: false}

  hubsLayout = {
  };

  hubsGraph = {
    'layout': this.hubsLayout,
    data: [],
    type: 'PieChart'
  }

  usersLayout = {
  };

  usersGraph = {
    'layout': this.usersLayout,
    data: [],
    type: 'PieChart'
  }

  assistantsLayout = {
  };

  assistantsGraph = {
    'layout': this.assistantsLayout,
    data: [],
    type: 'PieChart'
  }

  dataSource: NbTreeGridDataSource<FSEntry>;


  startDate = moment().subtract(90,'days').toDate();
  endDate = moment().toDate();


  _comparePeriodChanged() {
    if(!this.showGlobalEngagement)
      return
    var n = 24 * 60 * 60 * 1000;
    if (this.selectedComparePeriod == '0') {
      n = 1 * n;
    }
    else if (this.selectedComparePeriod == '1') {
      n = 7 * n;
    }
    else if (this.selectedComparePeriod == '2') {
      n = 14 * n;
    }
    else if (this.selectedComparePeriod == '3') {
      n = 30 * n;
    }
    else if (this.selectedComparePeriod == '4') {
      n = 120 * n;
    }
    else if (this.selectedComparePeriod == '5') {
      n = 365 * n;
    }


    var p = new Date().getTime();
    var k = new Date(p - n);

    this.dashService.fetchEngagementData(k, p);

  }

  //handles display count according to selected period from dropdown list
  setDaysPeriod(){
    if(this.selectedDaysPeriod=='0'){
      this.dateRange={
        'startDate':"",
        'endDate':""
      };
      if(!this.summaryDataTimeout){
        this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForSevenDays'];
        this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInSevenDays'][0]['count'];
        this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForSevenDays'];
        this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
        this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInSevenDays'];
        this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
      }
    }else if(this.selectedDaysPeriod=='1'){
      this.dateRange={
        'startDate':"",
        'endDate':""
      };
      if(!this.summaryDataTimeout){
        this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForFifteenDays'];
        this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInFifteenDays'][0]['count'];
        this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForFifteenDays'];
        this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
        this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInFifteenDays'];
        this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
      }
    }else if(this.selectedDaysPeriod=='2'){
      this.dateRange={
        'startDate':"",
        'endDate':""
      };
      if(!this.summaryDataTimeout){
        this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForThirtyDays'];
        this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInThirtyDays'][0]['count'];
        this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForThirtyDays'];
        this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
        this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInThirtyDays'];
        this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
      }
    }else if(this.selectedDaysPeriod=='3'){
      this.loading=true;
      this.customSummaryTimeout=false;
      this.openCustomDatePicker();
    }
  }

  openCustomDatePicker(){
    this.dialog.open(CustomDaysSummaryComponent);
  }

  private userQuerySubject = new Subject<string>();

  searchUsers(query: string) {
    // console.log("search Users: " + query)
    this.userQuerySubject.next(query);
  }

  readonly custDatas$ = this.userQuerySubject.pipe(
    liveSearch(query => this.dashService.fetchUsers(query))
  );

  removeNonAlphaNumeric(str) {
    return str.replace(/[^a-zA-Z0-9@._%+-]/g, "");
  }

  constructor(public dashService: DashService, private toastrService: NbToastrService, public dialog: MatDialog, dataSourceBuilder: NbTreeGridDataSourceBuilder<FSEntry>, private searchService: NbSearchService) {
    this.searchService.onSearchInput()
      .subscribe((data: any) => {
        this.searchValue = data.term;
        let newTerm = this.removeNonAlphaNumeric(data.term);
        console.log(this.searchValue,"new Term:",newTerm);
        this.searchUsers(newTerm)
      })

    this.dataSource = dataSourceBuilder.create(this.data);
    this.dashDataSub = this.dashService.getdashDataListener().subscribe(
      dashDataStatus => {
        console.log(dashDataStatus);
        this.summary = [
          { title: 'Scenes', value: this.dashService.accountAnalytics["sceneCount"] },
          { title: 'Rules', value: this.dashService.accountAnalytics["ruleCount"] },
          { title: 'Cameras', value: this.dashService.accountAnalytics["cameraCount"] },
          { title: 'Android (Last 24 Hrs)', value: this.dashService.accountAnalytics["androidInstallations"] },
          { title: 'IOS (Last 24 Hrs)', value: this.dashService.accountAnalytics["iosInstallations"] }
        ]
        console.log(this.dashService.engagementData);
        var trace1 = {
          x: ['ruleCount', 'sceneCount', 'AlexaCount', 'GoogleAssistantCount', 'operationsCount', 'eventsCount'],
          y: [this.dashService.engagementData['ruleCountLast'], this.dashService.engagementData['sceneCountLast'], this.dashService.engagementData['AlexaCountLast'], this.dashService.engagementData['GoogleAssistantCountLast'], this.dashService.engagementData['operationsCountLast'], this.dashService.engagementData['eventsCountLast']],
          name: 'Previous',
          type: 'bar'
        };

        var trace2 = {
          x: ['ruleCount', 'sceneCount', 'AlexaCount', 'GoogleAssistantCount', 'operationsCount', 'eventsCount'],
          y: [this.dashService.engagementData['ruleCountNow'], this.dashService.engagementData['sceneCountNow'], this.dashService.engagementData['AlexaCountNow'], this.dashService.engagementData['GoogleAssistantCountNow'], this.dashService.engagementData['operationsCountNow'], this.dashService.engagementData['eventsCountNow']],
          name: 'Now',
          type: 'bar'
        };

        var data = [trace1, trace2];
        this.engagementGraph['data'] = data;
      }
    );

    this.dashDataInfoSub = this.dashService.getdashInfoDataListener().subscribe(dashDataInfoStatus => {
      this.dashInfo = this.dashService.dashInfo
      console.log(this.dashInfo)
      // var hubsData = [{
      //   values: [this.dashInfo[2], this.dashInfo[3]],
      //   labels: ['Hubs Online', 'Hubs Offline'],
      //   type: 'pie'
      // }];

      var hubsData = [
        ['Hubs Online', this.dashInfo[2]],
        ['Hubs Offline', this.dashInfo[3]],
      ];

      this.hubsGraph['data'] = hubsData

      // var usersData = [{
      //   values: [this.dashInfo[0], this.dashInfo[1]],
      //   labels: ['users with hub', 'users without hubs'],
      //   type: 'pie'
      // }];

      var usersData = [
        ['users with hub', this.dashInfo[0]],
        ['users without hubs', this.dashInfo[1]],
      ];

      this.usersGraph['data'] = usersData

      // var assistantsData = [{
      //   values: [this.dashInfo[4], this.dashInfo[5],this.dashInfo[6], this.dashInfo[7] ],
      //   labels: ['Google Assistant', 'Alexa', 'Both', 'None'],
      //   type: 'pie'
      // }];


      var assistantsData = [
        ['Google Assistant', this.dashInfo[4]],
        ['Alexa', this.dashInfo[5]],
        ['Both', this.dashInfo[6]],
        ['None', this.dashInfo[7]],
      ];
      this.assistantsGraph['data'] = assistantsData;

      this.drawRegionsMap()
    });

    //*
    this.dashSummarySub=this.dashService.getSummaryDataListener().subscribe(dashSummaryStatus=>{
      if(dashSummaryStatus){
        this.hubUsersData=this.dashService.summaryData['data']['installationData']['hubUsersData'];
        this.dataUpdatedTime=this.dashService.summaryData['data']['dataUpdatedTime'];
        if(this.selectedDaysPeriod=='0'){
          this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForSevenDays'];
          this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInSevenDays'][0]['count'];
          this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForSevenDays'];
          this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
          this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInSevenDays'];
          this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
        }else if(this.selectedDaysPeriod=='1'){
          this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForFifteenDays'];
          this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInFifteenDays'][0]['count'];
          this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForFifteenDays'];
          this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
          this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInFifteenDays'];
          this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
        }else if(this.selectedDaysPeriod=='2'){
          this.hubsInstallCount=this.dashService.summaryData['data']['installationData']['hubs'][0]['countForThirtyDays'];
          this.hubsOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineHubsInThirtyDays'][0]['count'];
          this.nodeTypeInstallCount=this.dashService.summaryData['data']['installationData']['nodeTypeCountForThirtyDays'];
          this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
          this.nodeTypeOnlineCount=this.dashService.summaryData['data']['onlineData']['onlineNodesInThirtyDays'];
          this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
        }
        this.loading=false;
      }else{
        this.loading=false;
        this.summaryDataTimeout=true;
        this.showToast(5000, "Connection timed out", 'Please check your connection and try again !');
      }
    })
    //*

    this.dashCustomSummarySub=this.dashService.getCustomRangeSummaryDataListener().subscribe(dashSummaryStatus=>{
      if(dashSummaryStatus){
        this.dateRange.startDate=this.monthsArray[new Date(this.dashService.customSummaryData['data']['startDate']).getMonth()]+" "
                                +new Date(this.dashService.customSummaryData['data']['startDate']).getDate()+", "
                                +new Date(this.dashService.customSummaryData['data']['startDate']).getFullYear();
        this.dateRange.endDate=this.monthsArray[new Date(this.dashService.customSummaryData['data']['endDate']).getMonth()]+" "
                              +new Date(this.dashService.customSummaryData['data']['endDate']).getDate()+", "
                              +new Date(this.dashService.customSummaryData['data']['endDate']).getFullYear();
        this.dataUpdatedTime=this.dashService.customSummaryData['data']['dataUpdatedTime'];
  
          this.hubsInstallCount=this.dashService.customSummaryData['data']['installationData']['hubs'][0]['countForSelectedDays'];
          this.hubsOnlineCount=this.dashService.customSummaryData['data']['onlineData']['onlineHubsInSelectedDays'][0]['count'];
          this.nodeTypeInstallCount=this.dashService.customSummaryData['data']['installationData']['nodeTypeCountForSelectedDays'];
          this.totalNodesInstalled=this.nodeTypeInstallCount.reduce((sum,{count})=>sum+count,0);
          this.nodeTypeOnlineCount=this.dashService.customSummaryData['data']['onlineData']['onlineNodesInSelectedDays'];
          this.totalNodesOnline=this.nodeTypeOnlineCount.reduce((sum,{count})=>sum+count,0);
          this.loading=false;
          this.customSummaryTimeout=false;
      }else{
        this.loading=false;
        this.customSummaryTimeout=true;
        this.showToast(5000, "Connection timed out", 'Please check your connection and try again !');
      }
      
    })

    this.dashOneYearHubDataSub=this.dashService.getOneYearHubDataListener().subscribe(dashStatus=>{
      if(dashStatus){
        this.oneYearHubCount=this.dashService.oneYearHubCount;
        this.graphDataForLastYear=[this.dashService.graphDataForLastYear];
        this.graphDataTimeout=false;
        this.loadingGraphData=false;
      }else{
        this.loadingGraphData=false;
        this.graphDataTimeout=true;
        this.showToast(5000, "Connection timed out", 'Please check your connection and try again !');
      }
    })

    this.dashFirmwareDataSub=this.dashService.getFirmwareDataListener().subscribe(dashStatus=>{
      if(dashStatus){
        this.firmwareData=[this.dashService.firmwareData];
        this.oldHubFirmwareData=[this.dashService.oldHubFirmwareData];
        this.dataSourceForFirmwareCounts=[
          {'valueName':"Installations", 'valueCount':this.dashService.firmwareData.installationsForType, 'valuePercentage': this.dashService.firmwareData.typePercentage},
          {'valueName':"Online in 24 hours", 'valueCount':this.dashService.firmwareData.onlineInLastDay, 'valuePercentage': this.dashService.firmwareData.onlinePercentage}
        ];
        this.dataSourceForTotalFirmwareCounts=[
          {'valueName':"Total Installations", 'valueCount':this.dashService.firmwareData.totalFirmwareInstallations},
          {'valueName':"Total online in 24 hours", 'valueCount':this.dashService.firmwareData.totalOnlineInLastDay}
        ]
        this.dataSourceForOldHubTotalFirmwareCounts=[
          {'valueName':"Total Installations", 'valueCount':this.dashService.oldHubFirmwareData.totalFirmwareInstallations},
          {'valueName':"Total online in 24 hours", 'valueCount':this.dashService.oldHubFirmwareData.totalOnlineInLastDay}
        ]
        this.loadingAnalytics=false;
      }else if(!dashStatus){
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingAnalytics=false;
      }else{
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingAnalytics=false;
      }
    })
    this.dashReleasedNodeTypeDataSub=this.dashService.getReleasedNodeTypeDataListener().subscribe(dashStatus=>{
      if(dashStatus){
        this.releasedNodeTypeData=this.dashService.releasedNodeTypeData;
        if(this.releasedNodeTypeData.success && this.releasedNodeTypeData.customers){
          let customers = this.releasedNodeTypeData.customers;
          if(customers.length == 0){
            this.loadingReleaseAnalytics=false;
            this.showToast(3000, "Customers Not Found", "No customer data was found for that released node type");
            return;
          }
          let data = [];
          var total = 0;
          var totalOnline = 0;
          var totalOffline = 0;
          var serial = 1;
          for(var i=0;i<customers.length;i++){
            var customer = customers[i];
            if(customer.emailId && (customer.emailId.includes("myeglu.com") || customer.emailId.includes("wz.com") || customer.emailId.includes("wizn.com"))){
              continue;
            }
            var hubs = [];
            var nodes = [];
            var times = [];
            var firmwares = [];
            var onlines = [];
            for(var j=0;j<customer.hubs.length;j++){
              var hub = customer.hubs[j];
              for(var k=0;k<hub.nodes.length;k++){
                var node = hub.nodes[k];
                if(node.nodeType && node.nodeType == this.releasedNodeType.toUpperCase() && node.createdAt && (moment(node.createdAt).toDate() > this.startDate && moment(node.createdAt).toDate() < this.endDate)){
                  nodes.push(node.nodeId);
                  total += 1;
                  if(!hubs.includes(hub.hubId)) {
                    hubs.push(hub.hubId);
                  }
                  times.push(node.createdAt ? moment(node.createdAt).format('lll') : "")
                  firmwares.push(node.firmwareVersion);
                  let online = node.isOffline == undefined ? 'NO' : (node.isOffline ? 'NO' : 'YES');
                  onlines.push(online);
                  if(online == 'YES'){
                    totalOnline += 1;
                  }else {
                    totalOffline += 1;
                  }
                }
              }
            }
            if(nodes.length > 0){
              data.push({
                "Serial No":serial,
                "Name":customer.fullName,
                "Email ID":customer.emailId,
                "Moile":customer.mobile,
                "HUB IDs":hubs.join("\n"),
                "Node eIDs":nodes.join("\n"),
                "Online" : onlines.join("\n"),
                "Firmware Versions":firmwares.join("\n"),
                "Installation Time":times.join("\n")
              })
              serial += 1;
            }
          }
          data.push({
           
          })
          data.push({
            "Serial No":"",
            "Name":"",
            "Email ID":"",
            "Moile":"",
            "HUB IDs":"Total Count",
            "Node eIDs":total,
            "Online" : "",
            "Firmware Versions":"",
            "Installation Time":""
          })
          data.push({
            "Serial No":"",
            "Name":"",
            "Email ID":"",
            "Moile":"",
            "HUB IDs":"Total Online",
            "Node eIDs":totalOnline,
            "Online" : "",
            "Firmware Versions":"",
            "Installation Time":""
          })
          data.push({
            "Serial No":"",
            "Name":"",
            "Email ID":"",
            "Moile":"",
            "HUB IDs":"Total Offline",
            "Node eIDs":totalOffline,
            "Online" : "",
            "Firmware Versions":"",
            "Installation Time":""
          })
          const ws = utils.json_to_sheet(data);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, this.releasedNodeType.toUpperCase()+" Data");
          writeFile(wb, this.releasedNodeType.toUpperCase()+"_from_"+moment(this.startDate).format('lll').replace(" ","_")+"_to_"+moment(this.endDate).format('lll').replace(" ","_")+".xlsx");
          this.loadingReleaseAnalytics=false;
        }else {
          this.loadingReleaseAnalytics=false;
        }
      }else if(!dashStatus){
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingReleaseAnalytics=false;
      }else{
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingReleaseAnalytics=false;
      }
    })

    this.dashOldHubFirmwareDataSub=this.dashService.getOldHubFirmwareDataListener().subscribe(dashStatus=>{
      if(dashStatus){
        this.oldHubFirmwareData=[this.dashService.oldHubFirmwareData];
        this.dataSourceForOldHubTotalFirmwareCounts=[
          {'valueName':"Total Installations", 'valueCount':this.dashService.oldHubFirmwareData.totalFirmwareInstallations},
          {'valueName':"Total online in 24 hours", 'valueCount':this.dashService.oldHubFirmwareData.totalOnlineInLastDay}
        ]
        this.loadingAnalytics=false;
      }else if(!dashStatus){
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingAnalytics=false;
      }else{
        this.showToast(5000, "Connection timed out", "Failed to load data. Please try again !");
        this.loadingAnalytics=false;
      }
    })

  }


  downloadExcelFile(){
    this.dashService.getExcelFile();
  }

  onTabChanged($event){
    this.tabIndex=$event.index;
  }

  graphOptionToggled(){
    if(this.installationGraphChecked){
      this.installationGraphChecked=false;
      this.graphDataTimeout=false;
    }else{
      this.loadingGraphData=true;
      this.graphDataTimeout=false;
      this.installationGraphChecked=true;
      this.dashService.getOneYearHubData();
    }
  }

  ngOnInit(): void {
    this.dashService.fetchData()
    this._comparePeriodChanged()
    this.dashService.getSummary(); //*

    this.dashService.fetchOldHubFirmwareData();

    this.loadMap();

    this.getHubDataBaseInfo();
  }

  loadMap(){

  google.charts.load('current', {
        'packages': ['geochart'],
        // Load map data for India
        'mapsApiKey': 'YOUR_GOOGLE_MAPS_API_KEY' // optional for India
      });
  }

  drawRegionsMap() {
        const data = google.visualization.arrayToDataTable(this.dashService.statesData);

        const options = {
          region: 'IN', // Focus on India
          resolution: 'provinces', // State-level granularity
          colorAxis: {colors: ['#e0f3db', '#296a18']},
          backgroundColor: '#f5f5f5',
          datalessRegionColor: '#f0f0f0',
          defaultColor: '#f5f5f5'
        };

        const chart = new google.visualization.GeoChart(document.getElementById('regions_div'));
        chart.draw(data, options);
      }

  showToast(duration, messageTitle, messageContent) {
    this.toastrService.show(
      messageContent,
      messageTitle,
      { duration });
  }

  firmwareInfo(hubFirmwareVersion, hubType, equality){
    if(!hubFirmwareVersion.length){
      this.showToast(5000,"Firmware version cannot be blank","Please input valid firmware version !");
    }else if(hubFirmwareVersion.match('^[0-9]{14}$')){
      this.loadingAnalytics=true;
      this.dashService.fetchFirmwareData(hubFirmwareVersion, hubType, equality);
    }else{
      this.showToast(5000,"Invalid firmware version","Please input valid firmware version !");
    }
  }

  exportReleasedNodeType(){
    if(!this.releasedNodeType.length){
      this.showToast(5000,"Released Node Type cannot be blank","Please input valid released node type !");
      return;
    }
    this.loadingReleaseAnalytics=true;
    this.dashService.fetchReleasedNodeTypeData(this.releasedNodeType.toUpperCase(),this.startDate,this.endDate);
  }

  summary = [
    { title: 'Scenes', value: this.dashService.accountAnalytics["sceneCount"] },
    { title: 'Rules', value: this.dashService.accountAnalytics["ruleCount"] },
    { title: 'Cameras', value: this.dashService.accountAnalytics["cameraCount"] },
    { title: 'Installs', value: this.dashService.accountAnalytics["androidInstallations"] }
  ]

  showGlobalEngagement = false;

  private data: TreeNode<FSEntry>[] = [
  ];

  getHubDataBaseInfo(){
    this.isLoadingDatabaseAnalytics = true
    this.dashService.getDatabaseAnalyticsData((data)=>{
      this.isLoadingDatabaseAnalytics = false
      if(data) {
        this.databaseInfo = data;
      }
    });
  }

}

